import {
  DatabaseService,
  PaypalPayment,
  PaypalPaymentData,
  PaypalPaymentRepository,
} from "../core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getPaypalPaymentRepository(
  databaseService: DatabaseService,
): PaypalPaymentRepository {
  return getGenericRepository<PaypalPayment, PaypalPaymentData>(
    () => DatabaseCollection.PAYPAL_PAYMENTS,
    databaseService,
  );
}
